import React from 'react';
import { useTranslation } from 'react-i18next';
import formStyles from './Form.module.scss';
import DayPickerField from './DayPickerField';
import TimeOnlyPickerField from './TimeOnlyPickerField';
import { useFormikContext } from 'formik';

interface DateTimePickerFieldProps {
  name: string;
  disabledAfter?: Date;
  disabledBefore?: Date;
}

const DateTimePickerField: React.FC<DateTimePickerFieldProps> = ({ name, disabledAfter, disabledBefore }) => {
  const { t } = useTranslation('events');
  const { values } = useFormikContext<Record<string, any>>();
  const selectedDate = values[name] || null;

  return (
    <div className={formStyles.row}>
      <div className={formStyles.col}>
        <DayPickerField
          className={formStyles.InputField}
          name={name}
          disabledBefore={disabledBefore}
          disabledAfter={disabledAfter}
          placeholderText={t('settings.discountCodes.page.datePlaceholder')}
        />
      </div>
      <div className={formStyles.col}>
        <TimeOnlyPickerField
          wrapperClassName={formStyles.timepicker}
          className={formStyles.InputField}
          name={`${name}Time`}
          compareDate={selectedDate}
          disabledAfter={disabledAfter}
          disabledBefore={disabledBefore}
          placeholderText={t('settings.discountCodes.page.timePlaceholder')}
        />
      </div>
    </div>
  );
};



export default DateTimePickerField;
